import ViewPost from "./viewPost";

export default function ViewPostScreen() {
  return <ViewPost />;
}
